<template>
  <ul class="file-list list-group">
    <li v-for="(file, index) in adaptedFiles" :key="index" class="p-0 d-flex file-list-item list-group-item justify-content-between align-items-center">
      <div class="preview" v-if="file.thumbnail">
        <img :src="file.thumbnail.startsWith('data:image/') ? file.thumbnail : 'data:image/jpeg;base64,' + file.thumbnail" alt="thumbnail">
      </div>
      <div class="file-info">
        <div style="flex: 2" class="file-list-item-label">
          <a @click.prevent="startDownload(file)" :href="file && file.path">{{ file && file.name }}</a>
          <br>
          <small v-if="file && file.file_size" class="text-uppercase text-muted font-weight-bold">{{ file.file_size }}</small>
        </div>
        <base-button v-if="file && !file.path && remove !== false" @click="removeFile(file)" type="neutral" class="ml-3" size="sm">
          remover
        </base-button>
        <base-button v-if="file && file.path && remove == true" @click="removeFile(file)" type="neutral" class="ml-3" size="sm">
          remover
        </base-button>
      </div>
    </li>
  </ul>
</template>

<script>
export default {
  props: {
    files: {
      type: Array,
      default: () => [],
    },
    remove: {
      type: Boolean,
      default: null
    }
  },
  data: () => ({
    loadingFiles: [],
  }),
  computed: {
    adaptedFiles() {
      return this.files.map(file => this.adaptFileObject(file));
    }
  },
  methods: {
    adaptFileObject(fileObject) {
      if (fileObject.signed_id && fileObject.url) {
        return {
          id: fileObject.signed_id,
          name: fileObject.name,
          path: fileObject.url,
          file_size: fileObject.file_size,
          thumbnail: fileObject.thumbnail
        };
      }

      return fileObject;
    },
    removeFile(file) {
      this.$emit("remove", file);
      this.$emit("update:files", this.files.filter(f => f !== file));
      if (this.remove && file.path) {
        this.$emit("remove:file", file);
      }
    },
    icon(filename) {
      const extension = filename.split('.').pop();

      if (['pdf'].includes(extension)) return 'fa fa-file-pdf';
      if (['xlsx', 'xls', 'csv'].includes(extension)) return 'fa fa-file-excel';
      if (['doc', 'docx', 'odt'].includes(extension)) return 'fa fa-file-word';
      if (['ppt'].includes(extension)) return 'fa fa-file-powerpoint';
      if (['svg', 'png', 'jpg', 'jpeg', 'gif'].includes(extension)) return 'fa fa-file-image';
      if (['mp3', 'mp4', 'wav'].includes(extension)) return 'fa fa-music';
      if (['zip', 'rar', 'tar', 'tz', '7z'].includes(extension)) return 'fa fa-file-archive';

      return 'fa fa-file';
    },
    async startDownload(file) {
      if (file && file.path && file.name) {
        try {
          const response = await this.$http.secured.get(file.path, { responseType: 'blob' });
          this.progress = 100;
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.target = '_blank';
          link.setAttribute('download', file.name);
          document.body.appendChild(link);
          link.click();
        } catch (error) {
          console.error('Error on file download: ', error);
        }
      }
    },
  },
}
</script>

<style scoped lang="scss">
.file-list-item-label {
  word-break: break-word;
}

.file-list {
  padding: 0;

  li {
    display: flex;
    align-items: center;
    justify-content: stretch;
  }

  .file-info {
    flex: 1;
    padding: 10px;
    display: flex;
    align-items: center;
    justify-content: space-around;
  }

  .preview {
    flex: 0;
    border-right: 1px solid #ccc;

    img {
      padding: 0;
      width: 64px;
      height: 64px
    }
  }
}
</style>
